import { render } from "./app-alert-error.vue?vue&type=template&id=47627c59"
import script from "./app-alert-error.vue?vue&type=script&lang=js"
export * from "./app-alert-error.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/alert/app-alert-error.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47627c59"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47627c59', __exports__)) {
    console.log('reload')
    api.reload('47627c59', __exports__)
  }
  
  module.hot.accept("./app-alert-error.vue?vue&type=template&id=47627c59", () => {
    console.log('re-render')
    api.rerender('47627c59', render)
  })

}


export default __exports__